import { render, staticRenderFns } from "./MediateDirectorManage.vue?vue&type=template&id=a789fd2a&"
import script from "./MediateDirectorManage.vue?vue&type=script&lang=js&"
export * from "./MediateDirectorManage.vue?vue&type=script&lang=js&"
import style0 from "./MediateDirectorManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports